import React from "react";
import { Divider, Grid, Typography } from "@material-ui/core";
import PageConfig from "../../config";
import moment from "moment";

const SummeryWidget = ({ accumulators }) => {
  const { DATE_FORMAT } = PageConfig;
  const salesStartedDate =
    accumulators?.currentSaleMonthStartDate?.format(DATE_FORMAT) ?? "N?A";
  const salesEndDate =
    accumulators?.currenSalesMonthEndDate.format(DATE_FORMAT) ?? "N?A";
  const currentDate = moment().format(DATE_FORMAT);
  const nextMonthNewAds = accumulators?.nextMonthNewAds ?? "N/A";
  const nextMonthRenewAds = accumulators?.nextMonthRenewAds ?? "N/A";
  const nextMonthSalesTarget = accumulators?.nextMonthSalesTarget ?? "N/A";
  const currentNewAds = accumulators?.currentNewAds ?? "N/A";
  const currentRenewAds = accumulators?.currentRenewAds ?? "N/A";
  const currentTotalAds = accumulators?.currentTotalAds ?? "N/A";
  const currentDateIndex = accumulators?.currentDateIndex ?? 0;
  const numOfDays = accumulators?.numOfDays ?? 0;

  const currentAvgNewSales = accumulators?.currentAvgNewSales ?? 0;
  const currentAvgRenewals = accumulators?.currentAvgRenewals ?? 0;

  const currentImpactNewSales = currentNewAds - currentAvgNewSales;
  const newSaleImpactCssClass =
    currentImpactNewSales < 0 ? "impact-red" : "impact-green";
  const newSaleImpactText = `(${currentImpactNewSales} ads)`;

  const currentImpactRenewSales = currentRenewAds - currentAvgRenewals;
  const RenewSaleImpactCssClass =
    currentImpactRenewSales < 0 ? "impact-red" : "impact-green";
  const RenewSaleImpactText = `(${currentImpactRenewSales} ads)`;

  return (
    <Grid container direction="column" className="summery-widget gap-y-8">
      <Grid container direction="row" className="gap-x-16">
        <Typography variant="body2">
          <b className="pr-1">Today:</b> {currentDate}
        </Typography>
        <Typography variant="body2">
          <b className="pr-1">Start Date:</b>
          {salesStartedDate}
        </Typography>
        <Typography variant="body2">
          <b className="pr-1">End Date: </b>
          {salesEndDate}
        </Typography>
      </Grid>
      <Grid container direction="column" className="gap-y-8">
        <Grid container direction="column">
          <Typography variant="body2" className="font-semibold">
            Target
          </Typography>
          <Grid container direction="row" className="gap-x-16 px-8">
            <Typography variant="caption" className="flex-1">
              <b className="pr-1">New Ads:</b> {nextMonthNewAds}
            </Typography>
            <Typography variant="caption" className="flex-1">
              <b className="pr-1">Renewals:</b>
              {nextMonthRenewAds}
            </Typography>
            <Typography variant="caption" className="flex-1">
              <b className="pr-1">Total Sales: </b>
              {nextMonthSalesTarget}
            </Typography>
          </Grid>
        </Grid>
        <Divider />
        <Grid container direction="column">
          <Typography variant="body2" className="font-semibold">
            Progress Expectation
            <span className="average-value-text">
              (Based on Average values)
            </span>
          </Typography>
          <Grid container direction="row" className="gap-x-16 px-8">
            <Typography variant="caption" className="flex-1">
              <b className="pr-1">New Ads:</b> {currentAvgNewSales}
            </Typography>
            <Typography variant="caption" className="flex-1">
              <b className="pr-1">Renewals:</b>
              {currentAvgRenewals}
            </Typography>
            <Typography variant="caption" className="flex-1">
              <b className="pr-1">Total Sales: </b>
              {currentAvgNewSales + currentAvgRenewals}
            </Typography>
          </Grid>
        </Grid>
        <Divider />
        <Grid container direction="column">
          <Typography variant="body2" className="font-semibold">
            Current Status
            <span className="day-indicator">
              ({numOfDays - currentDateIndex} days remaining)
            </span>
          </Typography>
          <Grid container direction="row" className="gap-x-16 px-8">
            <Typography variant="caption" className="flex-1">
              <b className="pr-1">New Ads:</b> {currentNewAds}
              <span className={newSaleImpactCssClass}>{newSaleImpactText}</span>
            </Typography>
            <Typography variant="caption" className="flex-1">
              <b className="pr-1">Renewals:</b>
              {currentRenewAds}
              <span className={RenewSaleImpactCssClass}>
                {RenewSaleImpactText}
              </span>
            </Typography>
            <Typography variant="caption" className="flex-1">
              <b className="pr-1">Total Sales: </b>
              {currentTotalAds}
            </Typography>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default SummeryWidget;
